<template>
  <div class="custom-popup" v-if="visible">
    <div class="overlay" @click="close"></div>
    <div
      class="popup-content"
      :class="{ center: position === 'center', bottom: position === 'bottom' }"
      :style="{ borderRadius: (!isRadius && position === 'center') ? '0' : '' }"
    >
      <!-- 底部展示时，关闭按钮在内容上方 -->
      <div v-if="position === 'bottom'" class="close-btn" @click="close">
        <span class="iconfont icon-jujueweituo"></span>
      </div>
      <slot></slot>
      <!-- 居中展示时，关闭按钮在内容下方 -->
      <div v-if="position === 'center'" class="close-btn" @click="close">
        <span class="iconfont icon-jujueweituo"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否设置弹窗圆角半径
    isRadius: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "center",
      validator: (value) => ["center", "bottom"].includes(value),
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.custom-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000001;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.popup-content {
  position: fixed;
  background-color: white;
  z-index: 100001;

}

.center {
  width: 660px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 30px;
}
.center .close-btn {
  bottom: -110px;
}

.bottom {
  width: 700px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 30px 30px 0 0;
}
.bottom .close-btn{
  top: -110px;
}

.close-btn {
  text-align: center;
  padding: 10px;
  font-size: 24px;
  cursor: pointer;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.icon-jujueweituo {
  font-size: 68px;
  color: #fff;
}
</style>